// Tailwind's own palette, not arbitrary hex — these are design tokens, so an
// app-wide theme change (a repainted `blue` or `violet` scale) carries these
// avatars along with it instead of leaving them stuck on a one-off value.
const INITIALS_BACKGROUNDS = [
  'bg-blue-600 text-white',
  'bg-violet-600 text-white',
  'bg-cyan-600 text-white',
  'bg-fuchsia-600 text-white',
];

/** Up to two letters for a label with no image of its own. */
export const typeInitials = (label) => {
  if (!label?.trim()) return '?';
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return label.trim().slice(0, 2).toUpperCase();
};

/**
 * A stable accent for a label, derived from the label itself.
 *
 * Deterministic rather than random or index-based: the same type keeps its
 * colour across reloads and across pages, and a type appearing in a different
 * order does not silently change colour.
 */
export const typeAccentClass = (label) => {
  let sum = 0;
  const value = label || '';
  for (let i = 0; i < value.length; i += 1) sum += value.charCodeAt(i);
  return INITIALS_BACKGROUNDS[sum % INITIALS_BACKGROUNDS.length];
};
